import { render, staticRenderFns } from "./TachyonParticles.vue?vue&type=template&id=d31a6422&scoped=true"
import script from "./TachyonParticles.vue?vue&type=script&lang=js"
export * from "./TachyonParticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31a6422",
  null
  
)

export default component.exports